import React, { useRef } from "react";
import Header from "../../components/layout-component/header";
import HeroSection from "../../components/home/herosection";
import Collection from "../collection";
import CardCollection from "../../pages/card-collection";
import Footer from "../../components/layout-component/footer";
import DigitalTreasures from "../../components/home/digital-treasure";
import ShoeBanner from "../../components/shoe-banner";

const Home = () => {
  const productRef = useRef(null);

  const scrollToProduct = () => {
    if (productRef.current) {
      productRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <>
      <Header />
      <HeroSection scrollToProduct={scrollToProduct} />
      <DigitalTreasures />
      <ShoeBanner />
      <Collection />
      <CardCollection productRef={productRef} />
      <Footer />
    </>
  );
};

export default Home;
